import * as THREE from 'three'
import { DoubleSide } from 'three'
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js'
import gsap from 'gsap'

//Kaart
export default class Kaart {
    constructor(world) {
        this.world = world
        this.scene = this.world.scenes['scene-1']
        this.resources = this.world.stateController.resources.items
        this.time = this.world.time
        this.debug = this.world.debug
        this.camera = this.world.camera.perspectiveCamera
        this.sizes = this.world.sizes
        this.renderer = this.world.renderer

        //Setup
        this.setDebug()
        this.setTextures()
        this.setMapShader()
        this.setMaterials()
        this.setModel()
        this.setInstancing()
    }

    setDebug() {
        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Kaart')
            this.treesFolder = this.debug.ui.addFolder('Trees')
            //this.debugFolder.close()
        }
    }

    setTextures() {
        //TEXTURES
        this.resources.kaartOverzicht.name = 'kaartOverzicht'
        this.resources.cloudTexture.name = 'cloudTexture'
        this.resources.kaartRoughness.name = 'kaartRoughness'
        this.resources.treeTexture.name = 'treeTexture'

        this.textures = []
        this.textures.push(
            this.resources.kaartOverzicht,
            this.resources.cloudTexture,
            this.resources.kaartRoughness,
            this.resources.treeTexture,
        )

        // console.log(this.textures);
        this.textures.forEach(element => {
            element.encoding = THREE.sRGBEncoding
            element.flipY = false
            element.minFilter = THREE.LinearMipmapLinearFilter
            element.magFilter = THREE.LinearFilter
        });

        //LODS
        this.resources.LOD_close_1.name = 'LOD_close_1'
        this.resources.LOD_close_2.name = 'LOD_close_2'
        this.resources.LOD_close_3.name = 'LOD_close_3'

        this.lods = []
        this.lods.push(
            this.resources.LOD_close_0,
            this.resources.LOD_close_1,
            this.resources.LOD_close_2,
            this.resources.LOD_close_3,
            this.resources.LOD_close_4,
            this.resources.LOD_close_5,
            this.resources.LOD_close_6,
            this.resources.LOD_close_7,
            this.resources.LOD_close_8,
            this.resources.LOD_close_9,
            this.resources.LOD_close_10,
            this.resources.LOD_close_11,
            this.resources.LOD_close_12,
            this.resources.LOD_close_13,
            this.resources.LOD_close_14,
            this.resources.LOD_close_15,
            this.resources.LOD_close_16,
            this.resources.LOD_close_17,
            this.resources.LOD_close_18,
            this.resources.LOD_close_19,
            this.resources.LOD_close_20,
            this.resources.LOD_close_21,
            this.resources.LOD_close_22,
            this.resources.LOD_close_23,
            this.resources.LOD_close_24,

            this.resources.LOD_close_25,
            this.resources.LOD_close_26,
            this.resources.LOD_close_27,
            this.resources.LOD_close_28,
            this.resources.LOD_close_29,
            this.resources.LOD_close_30,
            this.resources.LOD_close_31,
            this.resources.LOD_close_32,
            this.resources.LOD_close_33,
            this.resources.LOD_close_34,
            this.resources.LOD_close_35,
            this.resources.LOD_close_36,
            this.resources.LOD_close_37,
            this.resources.LOD_close_38,
            this.resources.LOD_close_39,
            this.resources.LOD_close_40,
            this.resources.LOD_close_41,
            this.resources.LOD_close_42,
            this.resources.LOD_close_43,
            this.resources.LOD_close_44,
            this.resources.LOD_close_45,
            this.resources.LOD_close_46,
            this.resources.LOD_close_47,
            this.resources.LOD_close_48,
        )

        this.lods.forEach(element => {
            element.encoding = THREE.sRGBEncoding
            element.minFilter = THREE.LinearMipmapLinearFilter
            element.magFilter = THREE.LinearFilter
            element.wrapS = THREE.RepeatWrapping
            element.wrapT = THREE.RepeatWrapping
            element.repeat.set(7,7)
            element.flipY = false
        });

        //lods roughtness
        this.lods_rough = []
        this.lods_rough.push(
            this.resources.rough_close_0,
            this.resources.rough_close_1,
            this.resources.rough_close_2,
            this.resources.rough_close_3,
            this.resources.rough_close_4,
            this.resources.rough_close_5,
            this.resources.rough_close_6,
            this.resources.rough_close_7,
            this.resources.rough_close_8,
            this.resources.rough_close_9,
            this.resources.rough_close_10,
            this.resources.rough_close_11,
            this.resources.rough_close_12,
            this.resources.rough_close_13,
            this.resources.rough_close_14,
            this.resources.rough_close_15,
            this.resources.rough_close_16,
            this.resources.rough_close_17,
            this.resources.rough_close_18,
            this.resources.rough_close_19,
            this.resources.rough_close_20,
            this.resources.rough_close_21,
            this.resources.rough_close_22,
            this.resources.rough_close_23,
            this.resources.rough_close_24,

            this.resources.rough_close_25,
            this.resources.rough_close_26,
            this.resources.rough_close_27,
            this.resources.rough_close_28,
            this.resources.rough_close_29,
            this.resources.rough_close_30,
            this.resources.rough_close_31,
            this.resources.rough_close_32,
            this.resources.rough_close_33,
            this.resources.rough_close_34,
            this.resources.rough_close_35,
            this.resources.rough_close_36,
            this.resources.rough_close_37,
            this.resources.rough_close_38,
            this.resources.rough_close_39,
            this.resources.rough_close_40,
            this.resources.rough_close_41,
            this.resources.rough_close_42,
            this.resources.rough_close_43,
            this.resources.rough_close_44,
            this.resources.rough_close_45,
            this.resources.rough_close_46,
            this.resources.rough_close_47,
            this.resources.rough_close_48,
        )

        this.lods_rough.forEach(element => {
            element.wrapS = THREE.RepeatWrapping
            element.wrapT = THREE.RepeatWrapping
            element.flipY = false
        });
    }

    setMapShader() {       
        //textures voor kaart shader
        this.shaderMaterial = []
        this.uniforms = []
        this.resolution = new THREE.Vector3(this.sizes.width, this.sizes.height, this.sizes.pixelRatio)

        //volledige kaart
        this.mapMaterial = new THREE.MeshStandardMaterial({
            map: this.resources.kaartOverzicht,
            roughnessMap: this.textures[2],
        })

        this.mapMaterial.receiveShadows = true

        //highQ
        this.highQMaterial = []
        for (var i = 1; i < 50; ++i) {
            this.highQMaterial[i] = new THREE.MeshStandardMaterial({
                map: this.lods[i-1],
                roughnessMap: this.lods_rough[i-1]
            })

            //pre-loading the textures
            this.world.renderer.instance.initTexture(this.lods[i-1])
            this.highQMaterial.push(this.highQMaterial[i])
        }
    }

    setMaterials() {
        this.mapPlaceholderMaterial = new THREE.MeshStandardMaterial({
            map: this.resources.kaartOverzicht,
        })
        this.treeMaterial = new THREE.MeshStandardMaterial({
            map: this.textures[3],
        })

        this.standardMaterial = new THREE.MeshStandardMaterial({ color: 0x000000 })
        this.outlineMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 })
        this.routeMaterial = new THREE.MeshBasicMaterial({ color: 0x000000, side: DoubleSide })
        this.curveMaterial = new THREE.LineBasicMaterial({ color: 0xff0000 })

        // cloud material
        this.cloudMaterial = new THREE.MeshStandardMaterial({
            map: this.textures[1],
            transparent: true,
            opacity: 0.068
        })
    }

    setModel() {
        //GLTF
        this.kaartGltf = this.resources.kaartGltf
        this.kaartModel = this.kaartGltf.scene
        this.scene.add(this.kaartModel)
        // console.log(this.kaartModel);

        //kaart planes
        this.plane = [];
        for (var i = 1; i < 50; ++i) {
            let number = i.toString()
            this.kaart = this.kaartModel.children.find((child) => child.name === 'Kaart')
            this.plane[i] = this.kaart.children.find((child) => child.name === number)
            this.plane[i].material = this.mapMaterial
            this.plane[i].receiveShadow = true
        }

        //Cloud group
        this.clouds = this.kaartModel.getObjectByName('Clouds')
        this.clouds.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.material = this.cloudMaterial
                child.rotation.x = Math.PI /5
            }
        })

        //naming the clouds for interaction
        this.cloud_1 = this.clouds.getObjectByName('cloud_1')
        this.cloud_2 = this.clouds.getObjectByName('cloud_2')
        this.cloud_3 = this.clouds.getObjectByName('cloud_3')
        this.cloud_4 = this.clouds.getObjectByName('cloud_4')
        this.cloud_5 = this.clouds.getObjectByName('cloud_5')
        this.cloud_6 = this.clouds.getObjectByName('cloud_6')
        this.cloud_7 = this.clouds.getObjectByName('cloud_7')
        this.cloud_8 = this.clouds.getObjectByName('cloud_8')
        this.cloud_9 = this.clouds.getObjectByName('cloud_9')

        //uitloop kaart
        this.sides = this.kaartModel.children.find((child) => child.name === 'sides')
        this.sides.material = this.outlineMaterial

        //debug
        if (this.debug.active) {
            this.debugFolder.add(this.clouds, 'visible').name('Clouds')
            this.debugFolder.add(this.cloudMaterial, 'opacity').name('Cloud opacity')
                .min(0)
                .max(0.1)
                .step(0.001) 
        }
    }
    
    setInstancing() {
        //Model
        this.tree = this.kaartModel.getObjectByName('tree')
        this.treeOutline = this.kaartModel.getObjectByName('treeOutline')
        this.tree.visible = false
        this.treeOutline.visible = false
        
        const treeGeometry = this.tree.geometry.clone()
        const treeOutlineGeometry = this.treeOutline.geometry.clone()

        // //Transforming the object before instancing
        const treeTransform = new THREE.Matrix4().multiply(new THREE.Matrix4().makeScale(1,1,1))
        treeGeometry.applyMatrix4(treeTransform)
        treeOutlineGeometry.applyMatrix4(treeTransform)


        //Amount of instances
        const count = 3500
        this.instanceCount = {
            value: 3500
        }

        const treeOutlineMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 })
        this.tree = new THREE.InstancedMesh(treeGeometry, this.treeMaterial, count)
        this.treeOutline = new THREE.InstancedMesh(treeOutlineGeometry, treeOutlineMaterial, count)

        //Instances
        this.scene.add(this.tree)
        this.scene.add(this.treeOutline)

        //Instancing target
        this.target = this.kaartModel.getObjectByName('tree_target')
        this.target.material.wireframe = false
        this.target.visible = false

        // takes the planes as target
        const sampler = new MeshSurfaceSampler(this.target)
            .setWeightAttribute( 'color' )
            .build();

        //Instances op de juiste plek plaatsen
        this.tree.position.copy(this.target.position)
        this.treeOutline.position.copy(this.target.position)

        // Create a dummy Vector to store the sampled coordinates
        const tempPosition = new THREE.Vector3();
        const tempObject = new THREE.Object3D();
        var _normal = new THREE.Vector3();

        // Loop as many spheres we have
        for (let i = 0; i <  count; i++) {
            // Sample a random point on the surface of the cube
            sampler.sample(tempPosition, _normal);
            tempObject.position.set(tempPosition.x, tempPosition.y, tempPosition.z);
            tempObject.rotation.set(_normal.x/10, Math.random() * Math.PI, _normal.y/10);
    
            tempObject.scale.setScalar(Math.random() * 0.5 + 0.5);
            tempObject.updateMatrix();

            // plaats de sphered op de temporary
            this.tree.setMatrixAt(i, tempObject.matrix);
            this.treeOutline.setMatrixAt(i, tempObject.matrix);
        }

        if (this.debug.active) {
            this.treesFolder.add(this.instanceCount, 'value').name('Tree amount')
                .min(0)
                .max(3500)
                .step(10)   
                .onChange(() =>
                {
                    this.tree.count = this.instanceCount.value
                    this.treeOutline.count = this.instanceCount.value
                })
            this.treesFolder.add(this.tree, 'visible').name('Tree')
            this.treesFolder.add(this.treeOutline, 'visible').name('Tree outline')
        }
    } 

    update() {
        //distance for texture swap
        //this.LOD_distance = 18

        //texture swap based on distance
        for (var i = 1; i < 50; ++i) {
            this.distance = this.camera.position.distanceTo(this.plane[i].position)

            if(this.distance < this.LOD_distance){
                this.plane[i].material = this.highQMaterial[i]
            }
            else{
                this.plane[i].material = this.mapMaterial
            }
        }

        //Clouds animation on camera y position
        var y_zoom = this.camera.position.y

        //mapping the y position to cloud position
        var cloud_1_map = gsap.utils.mapRange(2, 24, 28, 9, y_zoom)
        var cloud_2_map = gsap.utils.mapRange(2, 24, 20, 7.5, y_zoom)
        var cloud_3_map = gsap.utils.mapRange(4, 24, -23, -9, y_zoom)
        var cloud_4_map = gsap.utils.mapRange(2, 24, -28, -13, y_zoom)
        var cloud_5_map = gsap.utils.mapRange(2, 24, 15, 3, y_zoom)
        var cloud_6_map = gsap.utils.mapRange(6, 24, -23, -11, y_zoom)
        var cloud_7_map = gsap.utils.mapRange(2, 24, 20, 9.5, y_zoom)
        var cloud_8_map = gsap.utils.mapRange(2, 24, -18, -15, y_zoom)
        var cloud_9_map = gsap.utils.mapRange(8, 24, 25, 5, y_zoom)

        //assigning the map to the cloud position
        this.cloud_1.position.x = cloud_1_map
        this.cloud_2.position.x = cloud_2_map
        this.cloud_3.position.x = cloud_3_map
        this.cloud_4.position.x = cloud_4_map
        this.cloud_5.position.x = cloud_5_map
        this.cloud_6.position.x = cloud_6_map
        this.cloud_7.position.x = cloud_7_map
        this.cloud_8.position.x = cloud_8_map
        this.cloud_9.position.x = cloud_9_map

        //cloud opacity on y pos
        var cloud_opacity_map = gsap.utils.mapRange(2, 24, 0, 0.075, y_zoom)
        this.cloudMaterial.opacity = cloud_opacity_map

        //setting up dynamic quility
        if (this.renderer.high === true) {
            this.clouds.visible = true
            this.tree.count = 3500
            this.treeOutline.count = 3500
            this.LOD_distance = 18

        }if (this.renderer.medium === true) {
            this.clouds.visible = true
            this.tree.count = 2000
            this.treeOutline.count = 2000
            this.LOD_distance = 18
        
        } if (this.renderer.low === true) {
            this.clouds.visible = false
            this.tree.count = 0
            this.treeOutline.count = 0
            this.LOD_distance = 0
        }
    }
}



